theme.collectionGrid = {
  init: firstLoad => {
    if (typeof(Storage) !== 'undefined') {
      this.dataGrid = localStorage.getItem('ProductGrid');

      if (this.dataGrid) {
        this.gridPC = parseInt(this.dataGrid.split('---')[0], 10);
        this.gridMB = parseInt(this.dataGrid.split('---')[1], 10);
      } else {
        this.gridPC = 3;
        this.gridMB = 2;
      }

      if (firstLoad) {
        document.querySelector('.product-display-pc button-grid[data-grid="'+ this.gridPC +'"]').classList.add('active');
        document.querySelector('.product-display-mb button-grid[data-grid="'+ this.gridMB +'"]').classList.add('active');
      }

      this.classGrid = [];

      if (this.gridPC == 3) {
        this.classGrid.push('pc-third-col');
      } else {
        this.classGrid.push('pc-quarter-col');
      }

      if (this.gridMB == 2) {
        this.classGrid.push('mb-half-col');
      } else {
        this.classGrid.push('mb-full-col');
      }

      setTimeout(() => {
        document.querySelector('collection-grid').className = '';
        document.querySelector('collection-grid').classList.add(...this.classGrid);

        document.querySelector('.collection-grid-loading').style.display = 'none';
        document.querySelector('.product-list').style.opacity = '1';
      }, 200);
    }
  },
  destroy: () => {
    document.querySelector('.collection-grid-loading').style.display = 'none';
    document.querySelector('.product-list').style.opacity = '1';
  }
};

class CollectionGridAction extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.changeGrid.bind(this));
  }

  changeGrid() {
    if (typeof(Storage) !== 'undefined') {
      if (this.classList.contains('active')) return;

      this.closest('.product-display-wrap').querySelector('button-grid.active').classList.remove('active');
      this.classList.add('active');

      this.btnPC = this.closest('.collection-product-display').querySelector('.product-display-pc button-grid.active');
      this.btnMB = this.closest('.collection-product-display').querySelector('.product-display-mb button-grid.active');
      this.dataGrid = this.btnPC.getAttribute('data-grid') + '---' + this.btnMB.getAttribute('data-grid')

      localStorage.setItem('ProductGrid', this.dataGrid);

      if (document.querySelectorAll('collection-grid').length > 0) {
        theme.collectionGrid.init();
      } else {
        theme.collectionGrid.destroy();
      }
    }
  }
}
customElements.define('button-grid', CollectionGridAction);

class CollectionGrid extends HTMLElement {
  constructor() {
    super();

    this.initGrid();
  }

  initGrid() {
    theme.collectionGrid.init(true);
  }
}

customElements.define('collection-grid', CollectionGrid);

class ShowColor extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.showColor.bind(this));
  }

  showColor() {
    this.style.display = 'none';
    this.closest('.swatches-and-price').querySelector('.cc-swatches').style.display = 'flex';
  }
}

customElements.define('show-color', ShowColor);

class ShowColorProduct extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.showColorProduct.bind(this));
  }

  showColorProduct() {
    this.style.display = 'none';
    this.closest('.product-block__inner').querySelector('.product-color').style.display = 'flex';
  }
}

customElements.define('show-color-product', ShowColorProduct);

class MoreColor extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.showMoreColor.bind(this));
  }

  showMoreColor() {
    this.style.display = 'none';
    if (this.closest('.cc-swatches').querySelectorAll('.hide-color').length > 0) {
      this.closest('.cc-swatches').querySelectorAll('.hide-color').forEach((colorSwatch) =>
        colorSwatch.classList.remove('hide-color')
      );
    }
  }
}

customElements.define('more-color', MoreColor);

$(document).ready(function() {
  collectionNav();

  $(window).resize(function() {
    collectionNav();
  })
})

function collectionNav() {
  if($('.js-collection-nav-slider').length > 0) {
    let navSlide = 0,
        navMax = $('.collection-nav-linklist').width();

    $('.js-cal-nav').each(function() {
      navSlide += parseInt($(this).outerWidth(), 10);
    });

    if (navSlide > navMax) {
      if (!$('.js-collection-nav-slider').hasClass('slick-slider')) {
        $('.js-collection-nav-slider').slick({
          dots: false,
          arrows: true,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          centerMode: false,
          variableWidth: true,
          draggable: false
        });
      }
    } else {
      if ($('.js-collection-nav-slider').hasClass('slick-slider')) {
        $('.js-collection-nav-slider').slick('unslick');
      }
    }
  }
}